interface JoinResponse {
  tenantId: string;
  [key: string]: any;
}

interface ErrorResponse {
  error: string;
}

export const checkOrganizationExists = async (orgId: string): Promise<boolean> => {
  try {
    const normalizedOrgId = orgId.trim().toLowerCase();
    const response = await fetch(`${process.env.REACT_APP_API_URL}/tenants/${encodeURIComponent(normalizedOrgId)}/exists`);
    if (!response.ok) {
      throw new Error('Failed to check organization existence');
    }
    const result = await response.json();
    return result.exists;
  } catch (error) {
    console.error('Error checking organization:', error);
    throw new Error('Error checking organization. Please try again.');
  }
};

export const storeOrganizationData = (data: {
  name: string;
  email: string;
  password: string;
  orgId: string;
  orgName: string;
  orgDescription: string;
}) => {
  sessionStorage.setItem('orgCreationData', JSON.stringify(data));
  sessionStorage.setItem('fromOrgCreate', 'true');
};

export const joinOrganization = async (
  tenantId: string,
  data: {
    email: string;
    password: string;
    name: string;
    accessCode: string;
  }
): Promise<JoinResponse> => {
  const normalizedTenantId = tenantId.toLowerCase();
  const response = await fetch(`${process.env.REACT_APP_API_URL}/organizations/${normalizedTenantId}/join`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    const errorData = await response.json() as ErrorResponse;
    throw new Error(errorData.error || 'Failed to join organization');
  }

  return response.json() as Promise<JoinResponse>;
}; 